(ns iris.styles.tags
  (:require
   [shadow.css :refer [css]]))



(def $btn-dark
  ["btn"
   (css {:color "#fff"
         :background-color "#343a40"
         :border-color "#343a40"}
        ["&:hover, &:focus" {:color "#fff !important"
                             :background-color "#23272b"
                             :border-color "#1d2124"}])])
(def $text-dark 
  (css {:color "#343a40 !important"}))

;;   [".btn-dark" {:color "#fff"
;;                 :background-color "#343a40"
;;                 :border-color "#343a40"}]
;;   [".btn-dark:hover, .btn-dark:focus" {:color "#fff"
;;                                        :background-color "#23272b"
;;                                        :border-color "#1d2124"}]

;;   [".text-dark" {:color "#343a40 !important"}]


(def $btn-old-tag (css {:background "lightgray !important" :color "black"}))
(def $btn-new-tag (css {:background "lightcyan !important" :color "black"}))
(def $btn-selected-tag (css {:background "#f5eeaf !important" :color "black" :border-color "#eea236 !important"}))

(def $btn-control-tag ["btn"
                       "btn-sm"
                       $btn-selected-tag])

;; [:.btn-old-tag {:background "lightgray !important" :color "black"}]
;; [:.btn-new-tag {:background "lightcyan !important" :color "black"}
;; ;;  [:&:hover {:background "#c7e4ff !important"}]
;;  ]
;; [:.btn-selected-tag {:background "#f5eeaf !important" :color "black" :border-color "#eea236 !important"}
;; ;;  [:&:hover {:background-color "#f0ad4e !important"
;; ;;             :border-color "#d58512 !important"}]
;;  ]




(def $tags-form
  (css {:font-family "'Open Sans', sans-serif"}))

(def $tags
  (css {:width "100%"
        :display "flex"
        :padding "0 10px"
        :font-family "'Open Sans', sans-serif"}
       ["&>.tags-list" {:display "flex"
                        :flex "1" ;; no space between <a> tags if I use only "flex 1" so added display "flex" and gap "5px", not sure if correct
                        :gap "5px"
                        :flex-wrap "wrap"
                        :align-items "end"
                        :margin-bottom "0px"}]
       ["&>.add-tags" {:align-self "flex-end"
                       :margin-top "10px"}]
       ["&>.add-tags>button" {:background "none !important"
                              :border "none"
                              :padding "0 !important"
                              :font-family "arial, sans-serif"
                              :font-weight "bold"
                              :color "#03c"
                              :text-decoration "none"
                              :cursor "pointer"}]
       ["&>.add-tags>button:hover" {:text-decoration "underline"}]))



(defn pending-grid [columns]
  (let [grid-template-columns (reduce (fn [s c]
                                        (let [[k v] c]
                                          (if (:show v)
                                            (str s " " (:size v))
                                            s)))
                                      ""
                                      columns)]
    {:display "grid"
     :grid-template-columns grid-template-columns}))

(def $table-grid
  (css
   ["&>thead" {:display "contents"}]
   ["&>thead tr" {:display "contents"}]
   ["&>tbody" {:display "contents"}]
   ["&>tbody tr" {:display "contents"}]
   ["&>tbody tr.selected td" {:background "navy !important" :color "white"}]))



;;   [:.table-grid
;;   ;;  {:display "grid"
;;   ;;               ;; :grid-template-columns "minmax(0px, 30px) minmax(0px, 100px) minmax(0px, 150px) minmax(150px, 500px) minmax(0px, auto) minmax(0px, 150px) minmax(0px, 90px) minmax(0px, 70px) minmax(0px, 70px)"
;;   ;;                :grid-template-columns "0.5fr 1fr 1fr 3fr 4fr 0.5fr 1fr 1fr 0.5fr 0.5fr"
;;   ;;               ;;  :grid-template-columns "auto" ;; mobile
;;   ;;                }
;;    [:thead {:display "contents"}]
;;    [:tbody {:display "contents"}]
;;    [:tr {:display "contents"}]
;;    [:tr.selected
;;     [:td {:background "navy !important" :color "white"}]]
;; ;; mobile:
;;   ;;  [:tr {:display "grid"
;;   ;;        :grid-template-columns "repeat(2, 1fr)"}]
;;   ;;  [:td {:white-space "initial !important"}]
;;   ;;  [:td.mob-full-row {:grid-column "1 / 3"}]
;;    ]


;; [:.tags-form {:font-family "'Open Sans', sans-serif"}]

;; [:.tags {:width "100%"
;;          :display "flex"
;;          :padding "0 10px"
;;          :font-family "'Open Sans', sans-serif"}
;;  [:.tags-list {:display "flex"
;;                :flex "1" ;; no space between <a> tags if I use only "flex 1" so added display "flex" and gap "5px", not sure if correct
;;                :gap "5px"
;;                :flex-wrap "wrap"
;;                :align-items "end"}]
;;  [:.add-tags {:align-self "flex-end"
;;               :margin-top "10px"}
;;   [:button {:background "none !important"
;;             :border "none"
;;             :padding "0 !important"
;;             :font-family "arial, sans-serif"
;;             :font-weight "bold"
;;             :color "#03c"
;;             :text-decoration "none"
;;             :cursor "pointer"
;;             :&:hover {:text-decoration "underline"}}]]]





;; .tags{
;;     width: 100%; // wonder if we can do without this? replies work fine without it, op does not
;;     display: flex;
;;     padding: 0 5px;

;;     .tags-list{
;;         flex: 1
;;     }

;;     .add-tags{
;;         align-self:flex-end;

;;         button {
;;             background: none!important;
;;             border: none;
;;             padding: 0!important;
;;             font-family: arial, sans-serif;
;;             font-weight: bold;
;;             color: #03c;
;;             text-decoration: none;
;;             cursor: pointer;
;;             &:hover{
;;               text-decoration: underline;
;;             }
;;         }
;;     }
;; }

;; .mobile {
;;     .tags{
;;         flex-wrap: wrap;
;;         .tags-list{
;;             flex: 1 0 100%;
;;         }
;;         .add-tags{
;;             flex: 1 0 100%;

;;             button {
;;                 float: right;
;;             }
;;         }
;;     }
;; }

;; AutoTags AI

(def $btn-ai-service
  (css {:padding "8px 12px"
        :cursor "pointer"
        :border-radius "34px"}
       ["@media (min-width: 480px)" {:padding "8px 16px"}]))

(def $btn-chatgpt1
  [$btn-ai-service
   (css {:border "2px solid #007BFF"})])

(def $btn-chatgpt2
  [$btn-ai-service
   (css {:border "2px solid #FF7A00"})])

(def $btn-chatgpt3
  [$btn-ai-service
   (css {:border "2px solid #00C851"})])